import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { LoadState } from '../../store/reducers/shared/mainLoad.reducers';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  LoadingActive = false;
  MainLoading = new Subscription();

  constructor(
    private store: Store<AppState>
    ) { }

  ngOnInit() {
    this.MainLoading = this.store.select( 'MainLoad').subscribe((Estado: LoadState) => {
      this.LoadingActive = Estado.Activo;
    });
  }

}
